import React from 'react';
// import {Link} from 'react-router-dom'
import C18DateFormat00 from './C18DateFormat00'
import C18Anchor00 from './C18Anchor00'
import {loadZonesInfo,getZoneInfo,getZoneIndex,loadSiteData,getSetpoints,getCurrentSetpoint,/*updateSensors,*/
  addSensor,makeSensors,makeSensors2,loadAddedSensorsInfo,
  loadCamerasInfo,loadGatewaysInfo,loadSensorsInfo,
  loadMBInfo,loadStationInfo,getUserIndex} from './C18utils'

import Gauge2 from '../../visualization/components/Gauge01';
import {sensorIds, getParamId,getParamId2,stages,humStages,tempUnit,lightUnit,
  bVolUnit,sVolUnit,
  windUnit,nuteUnit,initSensorIds,setSensorIdNames,wsTrans,getParamId800} from '../utils/utils'
import {dbVals,getZoneControllers} from '../../components/utils/http';
import {pInd} from '../../components/utils/paramIds';
import {cl,globs,constant,getTime,dateToDisplayDate,az,getRandomString,isHydroR} from '../../components/utils/utils';
import history from "../../history"
import {isHydroRoot16} from '../utils/utils'

class C18ZoneSensors00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.gauge={}
    this.state={
      loaded:false,
      mode:"sites",
      tileMode: false,
      sensors:[],
      curTime:getTime(),
      lastData:0,
      isHR16: false,
//       updateInterval: setInterval(this.update,10000),
    }
    this.checkZonesInt=setInterval(this.checkZone,60000)
    this.connectRefresh=setInterval(this.doRefresh,5000)
    this.subscribe_zoneUpdate=globs.events.subscribe("newZoneData",
      this.updateConnected)
  }
  
  componentWillUnmount=()=>{
//     cl("will unmount")
    clearInterval(this.checkZonesInt)
    clearInterval(this.connectRefresh)
    this.subscribe_zoneUpdate.remove()
//     clearInterval(this.state.updateInterval)
  }
  
//   componentDidUpdate(prevProps, prevState) {
//     cl("did update")
//   }

  componentDidMount() {
//     cl("did mount")
    globs.zonesInfo.got=false// forece reload on remount
    this.loadInfo()
  }

  checkDefaultSensors=(zo)=>{
    
  }

  updateSensors=()=>{
//     cl("update sensors")
//   cl(sensorIds["e0gn0"].name)
    let st=this.state
    let pa=this.props.parms
    let [sensors,zone,zInd]=makeSensors2(
      this,st.gwType,pa.site,pa.zone,this.hiLoAvSensors)
//     cl(sensors)
//   cl(sensorIds["e0gn0"].name)
    this.setState({sensors:sensors})
  }

  getSensors=async()=>{
    let res=await wsTrans("usa", {cmd: "cRest",
      uri: "/s/sensors", method: "retrieve",sessionId: globs.userData.session.sessionId,
      body: {
        cmd:"hiLoAv",
        siteId:this.zoneInfo.siteId,
        gatewayId:this.zoneInfo.gatewayId,
        zInd:this.zoneInfo.siteZoneIndex}})
//     cl("get sensors done")
    this.hiLoAvSensors=res.data.data
  }
  
  checkZone=async()=>{
// update if zone is connected
    // cl("check zone")
    globs.zonesInfo.got=false
    await loadZonesInfo()
    let zo=globs.zonesInfo.info.filter(z=>{return z?.zoneId==this.zone?.zoneId})[0]
    if(!zo){return}
    var gwType=zo?.gatewayType||1800
    // await this.getSensors()
    // cl("after get sensors")
//     cl(this.zone)
//     cl(zo)
    var zone,zInd,sensors=this.state.sensors
    let pa=this.props.parms
    // if(zo?.newZone){
//       gwType=1800
//       [sensors,zone,zInd]=await makeSensors(this,/*gwType*/1800,pa.site,pa.zone)
// [sensors,zone,zInd]=await makeSensors(this,gwType,pa.site,pa.zone)

      const makeRes=await makeSensors(
        this,gwType,pa.site,pa.zone,this.hiLoAvSensors)
      sensors = makeRes[0]
      zone = makeRes[1]
      zInd= makeRes[2]
      let isHR16=isHydroRoot16(zone?.zoneId)
      // console.log("🚀 ~ C18ZoneSensors00 ~ checkZone=async ~ sensors:", sensors)
      let now=getTime()
      if(now-zo.updateTime>600){
//         cl("turn off newZone")
        let writeZone={zoneId:zo.zoneId,newZone:false}
        wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update", 
          sessionId: globs.userData.session.sessionId, body: writeZone})
      }
    // }
    this.zone.connected=zo.connected
    this.zone.virtual=zo.virtual
    this.setState({updated:(this.state.updated||0)+1,
      sensors:sensors,gwType:gwType, isHR16})
  }
  
  loadInfo=async()=>{
//     let stateId=getParamId2(1900,"pearl_snaps","hdhState")
//     cl(stateId)
    // cl("load info zone sensors")
//     var sensors
    let pa=this.props.parms
//     cl(pa)
    await loadStationInfo()
//     cl("loaded stations")
//     cl(globs.stInfo)
    await loadAddedSensorsInfo()
    await loadCamerasInfo()
    await loadSiteData(pa.site)
    await loadSensorsInfo()
//     cl(dbVals.z)
//     await loadZonesInfo()
//     let zInd2=getZoneInfo(pa.zone).siteZoneIndex
//     cl(getZoneInfo(pa.zone).siteZoneIndex)
    initSensorIds(getZoneInfo(pa.zone).siteZoneIndex,true)
    await loadGatewaysInfo()
    await loadMBInfo(pa.site)
    this.zoneInfo=getZoneInfo(pa.zone)
    let isHR16=isHydroRoot16(this.zoneInfo?.zoneId)
    //await this.getSensors()
//     cl(this.zoneInfo)
//     cl(this.zoneInfo.gatewayType)
//     cl(globs)
//     cl("loaded&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
//     cl(pa)
//     cl(sensorIds)
//     cl(pa.zone)
//     cl("loadInfo")
//     cl(this.props)
//     let pa=this.props.parms
//     cl(this.props.parms)
//     setSensorIdNames()
    this.tankNames=[]
    let gwType=this.zoneInfo.gatewayType
//     cl(gwType)
    // cl(pa)
    let [sensors,zone,zInd]=await makeSensors(
      this,gwType,pa.site,pa.zone,this.hiLoAvSensors)
//     cl(sensors)
//     cl(sensors)
    // cl(zone)
//     cl(zInd)
    this.zone=zone
//     cl(this.zone)
    this.zInd=zInd
//     cl(zInd)
    let idx = getUserIndex(globs.userData.session.userId)
    if (idx!=-1) {
      let u = globs.usersInfo.info[idx]
      if(!u.apiKey){
        // cl("new one")
        u.apiKey=getRandomString(32)
        let res= await wsTrans("usa", {cmd: "cRest", uri: "/s/users", method: "update", 
          sessionId: globs.userData.session.sessionId, body: {userId:u.userId,apiKey:u.apiKey}})
      }
      this.apiKey = u.apiKey
    }
    this.setState({loaded:true,sensors:sensors,gwType:gwType, isHR16})
//   cl(((sensorIds||{})["e0gn0"]||{}).name)
//   setTimeout(e=>{cl(((sensorIds||{})["e0gn0"]||{}).name)},100)
//     cl(globs)
  }
  
//   update=async()=>{// seems not used
//     cl("do update sensors")
//     if(this.state.loaded){
// //       cl(this.zInd)
// //       cl(this.state.sensors)
//       initSensorIds(this.zInd)
//       if(this.zone){await setSensorIdNames(this.zone.zoneId)}
//       let gwType=this.zoneInfo.gatewayType
//       let sensRet=updateSensors(
//         this,gwType,
//         this.state.sensors,
//         this.props.parms.site,
//         this.zInd)
//       this.setState({sensors:sensRet})
//     }
//   }
  
  getCurVal3300=(vid)=>{
    cl(vid)
    let vals={
      spC:72,
      spH:68,
      taH:10,
      taL:10,
      stT:6,
      inT:70.5,
    }
    return (vals[vid])?vals[vid]:0
  }
  
  getCurVal=(vid)=>{
    let zone=dbVals.z[this.zone.siteZoneIndex]
    let [ch,pid]=this.getChPid(vid)
    return (zone[ch]||[])[pid]
  }
  
  getCurVal2=(vid)=>{
    let zone=dbVals.z[this.zone.siteZoneIndex]
    let [ch,pid]=this.getChPid(vid)
    return{val:zone[ch][pid],ch:ch,pid:pid}
//     return zone[ch][pid]
  }
//   getSnap=()=>{
//     
//   }

  scaleGauge=(min,max)=>{
/*max, min, should be the middle 25% of the total
hi and lo should be 1, 2, or 5 values
minmax: 68-72 4 degrees, 16 degrees total, rounded to 2:
62-78*/
    
  }
  
//   getTankNames=()=>{
//     let zone=dbVals.z[this.zone.siteZoneIndex]
// //     cl(zone)
//     let pid=sensorIds['taN'].id
// //     cl(pid)
//     let tankNames=[]
//     for(let i=192;i<200;i++){
// //       cl(zone[i])
//       let tn=((zone[i]||{})[pid])?zone[i][pid]:`Tank ${i-191}`
// //       cl(tn)
//       tankNames.push(tn)
//     }
// //     cl(tankNames)
//     return tankNames
//   }
//   
//   makeSensors=async()=>{
//     let sensors=[]
//     await loadZonesInfo()
// //     cl(globs.zonesInfo.info)
//     await loadSiteData(this.props.parms.site)
//     this.zone=getZoneInfo(this.props.parms.zone)
// //     cl(this.zone)
//     this.tankNames=this.getTankNames()
//     this.zInd=this.zone.siteZoneIndex
//     let sensorOrder=this.zone.sensorOrder||[]
//     sensorOrder.forEach(s=>{
// //       cl(s)
//       addSensor(sensors,s,this.props.parms.site,this.zInd)
//     })
//     cl(sensors)
//     this.setState({loaded:true,sensors:sensors})
//   }
  
  setGauge=(s)=>{
//     cl(s)
/*colors:
x
lo/hi: b0d9ff
mid: 67aded
pnt: 4bd087
cnt: f3f7ff
edg: e8efff
txt: a8a8a9
ttl: 6e6b7b
val: 393d46
unt: afb0b1

splow: c8c3ff
spmid: 0e01ac
sppnt: 0e01ac
*/
//       {name: "Inside Relative Humidity", type: "ga", vals:[-20, 0, 45, 65], cVal: 36, cUn: "% RH", val: 36, foot: "Normal"},
    let dark=(globs.device?.deviceTheme=="originalDark")?2:0
    let alarm=(s.al)?1:0
//     cl([dark,alarm])
//     cl(globs)
//     cl(dark)
//     cl(s)
    let val=s.val
    let bgColor=["#FFFFFF","#F4E5E5","#202020","#2b080c"][dark+alarm]
    let p={
      dec:1,
      mult:1,
      bgColor: bgColor,//(dark)?"#202020":"#FFFFFF",
      pntColor:"#4bd087",
      cntColor:(dark)?"#202020":"#f3f7ff",
      untColor:"#afb0b1",
      outRadius: 85,
      inRadius: 75,
      minVal: s.vals[0],
      maxVal:s.vals[s.vals.length-1],
    }
    let size=166
    let ga={}
    ga.value=s.val
    ga.centerValue=s.cVal
    ga.alarm=s.al
    ga.type=s.type
    ga.indText=s.indText// if displaying an index string
    ga.msg=s.msg
    ga.unit=s.cUn
    ga.unitColor=p.untColor
    ga.width=0.8*size-10//p.w-10,// sets size
    ga.height=0.62*size
    ga.fontSize=0.065*size//0.6*size,//12,
    ga.bgColor=p.bgColor
    ga.pointerColor=p.pntColor
    ga.centerColor=p.cntColor
    ga.ticks=s.vals
    if(s.type=="sp"){
      ga.tod=true
      ga.minAngle=0
      ga.maxAngle=360
      ga.colors=s.vals.map(v=>{return [v.start,v.col]})
//       ga.colors.unshift([0,"#c8c3ff"])
      ga.colors.push([1440+s.vals[0].start,"#FFFFFF"])
      ga.ticks=s.vals.map(v=>{return v.start})
//       cl(ga.colors)
//       s.vals.forEach(v=>{})
//       ga.colors=[
//       [0,"#c8c3ff"],
//       [s.vals[0],"#c8c3ff"],
//       [s.vals[1],"#0e01ac"],
//       [s.vals[2],"#c8c3ff"],
//       [1440,"#c8c3ff"],
//       [s.vals[3],"#FFFFFF"],
//       ]
      ga.min=0
      ga.max=1440
    }else{
      ga.minAngle=-120
      ga.maxAngle=120
      if(ga.ticks.length>2){
        ga.colors=[
        [s.vals[0],"#b0d9ff"],
        [s.vals[1],"#67aded"],
        [s.vals[2],"#b0d9ff"],
        [s.vals[3],"#FFFFFF"],
        ]
      }else{
        ga.colors=[
        [s.vals[0],"#b0d9ff"],
        [s.vals[1],"#FFFFFF"],
        ]
      }
      ga.min=p.minVal
      ga.max=p.maxVal
//       cl(ga.ticks)
    }

    ga.pntRadius=p.outRadius
    ga.ringInset=(size/2)*(100-p.outRadius)/100
    ga.ringWidth=(size/2)*(p.outRadius-p.inRadius)/100
//     ga.value=p.dataPoints.dp
//     ga.ticks=s.vals
    ga.update=this.update
//     cl(s)
//     cl(s.id)
//     cl(s.id.substring)
//     cl(ga)
//     if(s.id.substring(0,4)=="e0gn"){
//       this.fakeFixGn(s,ga)
//     }
//     cl(ga)
    return ga
  }

  fakeFixGn=(s,ga)=>{
//     cl(s)
//     cl(ga)
//     cl(s.id)
//     cl(s.id.substring(4))
    switch(s.id.substring(4)){
      case "0":// level
        ga.centerValue=67
        ga.value=67
        ga.colors[0]=[0,"#b0d9ff"]
        ga.colors[1]=[41,"#67aded"]
        ga.colors[2]=[82,"#b0d9ff"]
        ga.colors[3]=[100,"#FFFFFF"]
        ga.ticks=[0,41,82,100]
        s.foot="Avg: 61.0"
        cl(ga)
        break;
      case "1":// flow
        ga.centerValue=5.2
        ga.value=5.2
        ga.colors[0]=[0,"#b0d9ff"]
        ga.colors[1]=[0,"#67aded"]
        ga.colors[2]=[6.1,"#b0d9ff"]
        ga.colors[3]=[20,"#FFFFFF"]
        ga.ticks=[0,0,6.1,20]
//         ga.ticks=[0,6.1]
        ga.unit="gpm"
        ga.max=20
        s.foot="Total: 105.4"
//         ga.indText="what"
//         ga.colors[1][0]=6.1
        cl(ga)
        break;
      case "2":// temp
        ga.centerValue=72.3
        ga.value=72.3
        ga.colors[0]=[40,"#b0d9ff"]
        ga.colors[1]=[68.9,"#67aded"]
        ga.colors[2]=[73.1,"#b0d9ff"]
        ga.colors[3]=[100,"#FFFFFF"]
        ga.ticks=[40,68.9,73.1,100]
//         ga.ticks=[0,6.1]
        ga.unit="°F"
        ga.min=40
        ga.max=100
        s.foot="Avg: 70.6"
        break;
      case "3":// do
        ga.centerValue=10.3
        ga.value=10.3
        ga.colors[0]=[6,"#b0d9ff"]
        ga.colors[1]=[9.6,"#67aded"]
        ga.colors[2]=[10.9,"#b0d9ff"]
        ga.colors[3]=[12,"#FFFFFF"]
        ga.ticks=[6,9.6,10.9,12]
//         ga.ticks=[0,6.1]
        ga.unit="mg/L"
        ga.min=6
        ga.max=12
        s.foot="Avg: 10.7"
        cl(ga)
        break;
    }
    return
  }
  
  setSetpoint=()=>{
    this.setGauge()
    this.gauge.value=480
    this.gauge.centerValue=2
    this.gauge.tod=true// time of day
    this.gauge.unit=""
    this.gauge.minAngle=0
    this.gauge.maxAngle=360
    this.gauge.min=0
    this.gauge.max=1440
    this.gauge.colors=[
    [0,"#c8c3ff"],
    [360,"#0e01ac"],
    [720,"#c8c3ff"],
    [1440,"#FFFFFF"],
    ]
    this.gauge.ticks=[0, 360, 720, 1080]
    cl(this.gauge)
    
    
  }
  
  mbClick=()=>{
    window.open("https://www.tridium.com/us/en", "_blank")
  }

  zos800=(zi,index,unit)=>{
    cl(zi)
    let url=`/usa/c18/fui/setpoint_800/${index}-${unit}-240-0`
    history.push(url)
  }
  
  sensorClick=(e,id,type)=>{
//     cl(id,type)
//     cl(type)
    let zi=getZoneInfo(this.props.parms.zone)
//     cl(zi)
    let index=zi.siteZoneIndex
    e.preventDefault()
    var url
//     cl(id)
    let unit=+id.substring(1,2)
    let sId=id.substring(2)
    if(type.substring(0,2)=="mb"){return this.mbClick()}
    switch(sId){
      case "zoS":
        if(zi.gatewayType==800){return this.zos800(zi,index,unit)}
        url=`/usa/c18/fui/setpoints/${index}-${unit}-255-0`
        history.push(url)
        break
//       case "MB":
//         return this.mbClick()
      default:
        let p=this.props.parms
        url=`/usa/c18/sites/${p.site}/zones/${p.zone}/sensor/${id}`
//         url=`/usa/c18/sites/${p.site}/zones/${p.zone}/sensorGraph/${id}/l24`
//         url=`/usa/c18/fui/unit_Input_Calibration/${index}-0-240-0`
        history.push(url)
        break
    }
  }
  
  cameraClick=(e,cam)=>{
    e.preventDefault()
//     cl(this.props)
    this.props.parms.onChange({cmd:"camera",cam:cam})
    
  }
  
  showCamera=(cam,i)=>{
//     cl(cam)
//     cl(constant.camUrl)
    let cameraId=cam.id.substring(4)
    let now=Math.floor(getTime())
//     cl(constant.camUrl)
    return(
      <C18Anchor00 to="" key={i} className={`sensor-box`} aria-label={cam.name} onClick={e=>this.cameraClick(e,cam)}>
        <div className="name">{cam.name}</div>
        <img src={`${constant.camUrl}:${constant.camExpress}/camVideo/${cameraId}/${now}`}
        style={{marginTop:20,}}
          width="150"
        />
      </C18Anchor00>
    )
  }

  showOnOff=(s,i)=>{
//     cl(s)
    let sensorBoxClass=""
    let ledColor=(s.val>2.1)?"Green":"Gray"
    return(
            <C18Anchor00 to="" key={i} className={`sensor-box ${sensorBoxClass}`} aria-label={s.name} onClick={e=>this.sensorClick(e,s.id,s.type)}>
              <div className="name">{s.name}</div>
              <div style={{marginTop:19}}>
              <img src={`/img/${ledColor}Led.png`} width="100"/>
              </div>
              <div className="low-alarm alarm-icon">i</div>
              <div className="high-alarm alarm-icon">i</div>
            </C18Anchor00>
    )

  }
  
  showGaugeEtc=(showGauge,ga)=>{
    // cl(ga)
    if(showGauge){
      return <Gauge2 config={ga}/>
    }else{
//       cl(ga)
      if(["mbInd","mbIndAl"].includes(ga.type)){
//         cl(ga.indText)
        return(
          <div style={{paddingTop:30}}>
            <h3>{ga.indText}</h3>
          </div>
        )
      }
      if(ga.type=="st"){//station
        return ga.msg
      }
    }
  }

  makeIcons=(s,ga)=>{
//     cl(s)
//     cl(ga)
    let wid=1.2*ga.width
    let hgt=ga.height
//     cl(w,h)
    return s.icons.map((ic,i)=>{
      let x=wid*ic.x/100
      let y=hgt*ic.y/100
      let w=wid*ic.s/100
      let src1=`/img/${ic.i1}`
      let src2=`/img/${ic.i2}`
      let opac=ic.a/100
//       cl(ic)
//       cl(x,y,w)
      return (
      <div key={i}
        style={{
//           backgroundColor:"#EEEEEE",
          position:"absolute",
          left:x,
          top:y,
          width:100,
//           height:20,
        }}
      >
        <div style={{position:"relative"}}>
            <img style={{position:"absolute",left:0,top:0}} src={src1} width={w}/>
            <img style={{position:"absolute",left:0,top:0,opacity:opac}} src={src2} width={w}/>
        </div>
      </div>
      )
    }
    )
  }
  
  showSensors=()=>{
    // cl(this.state.sensors)
//     this.setGauge()
//     this.setSetpoint()
    let sensors=[]
//     cl(this.state.sensors)
// key={i} className={`sensor-box ${sensorBoxClass}`} aria-label={s.name} onClick={e=>e.preventDefault()}
//     cl(this.state.sensors)
    this.state.sensors.forEach((s,i)=>{
//       cl(s)
      if(s){
        if(["ga","sp","mb","st","mbAl","mbInd","mbIndAl","chan"].includes(s.type)){
          if(s.type==="sp"&&isHydroR(this.zone?.gatewayId)){return}
          let showGauge=!["mbAl","mbInd","mbIndAl","st"].includes(s.type)
  //         if(!showGauge){cl(s)}
  //         cl(showGauge)
          let ga=this.setGauge(s)
//           cl(ga)
          let stageClass=(s.hilo)?((s.hilo=="hi")?"heat":"cool"):""
          let sensorBoxClass={lo:"low-alarm-on",hi:"high-alarm-on",lohi:"low-alarm-on high-alarm-on"}[s.al]
          var icons=(s.icons)?this.makeIcons(s,ga):null
          let displayName=(this.state.isHR16&&s.name==="Inside Temperature" || s.name == "Inside Humidity")?s.name.replace("Inside",""):s.name
          sensors.push(
            <C18Anchor00 to="" key={i} className={`sensor-box ${sensorBoxClass}`} aria-label={displayName} onClick={e=>this.sensorClick(e,s.id,s.type)}>
              <div className="name">{displayName}</div>
              {this.showGaugeEtc(showGauge,ga)}
              <div className={`stage ${stageClass}`}>{s.foot}</div>
              <div className="low-alarm alarm-icon">i</div>
              <div className="high-alarm alarm-icon">i</div>
              {icons}
            </C18Anchor00>
          )
        }
        if(s.type=="ca"){
          sensors.push(this.showCamera(s,i))
        }
        if(s.type=="ono"){
          sensors.push(this.showOnOff(s,i))
        }
      }
      
    })
//     cl(sensors)
    return sensors
  }

  updateConnected=()=>{
//     cl("update connected")
//   cl(sensorIds["e0gn0"].name)
    if(sensorIds){
      this.updateSensors()
      this.setState({lastData:getTime()})
    }
  }

  doRefresh=()=>{
    this.setState({curTime:getTime()})
  }

  showConnected=()=>{
    let st=this.state
    let diff=st.curTime-st.lastData
    if(diff>60){diff=60}
    let opac=(60-diff)/60
    return(
      <div style={{position:"relative",left:0,top:0,
        width:20,height:20,borderRadius:10,backgroundColor:"#0080FF",
        opacity:opac
      }}/>
    )
  }
  
  
  render(){
//     cl(this.zone)
    var getTZIndicator=(tzo)=>{
      let hr=Math.floor(tzo/60)
      let mn=tzo%60
      if(hr>=0){hr=`+${hr}`}
//       cl(hr,mn)
      return `(UTC${hr}:${az(mn,2)})`
    }
    // cl("is HR16",this.state.isHR16)
//     cl(globs.zonesInfo.info)
//     cl("zoneSensor render")
//     cl(this.state.loaded)
//     cl(this.props)
    
// let al=+getParmValue(zi,240,se.ind,+getParamId("config_annex_sensors","alarmLow"))||0
//     cl(ts)
//     cl(id)
        
    if(this.state.loaded){
//       cl(this.state)
//       cl(this.zone)
//       this.zone.connected=false
//       cl(this.zone.gatewayType)
      var id
      let da=new Date()
      let tzo=0-da.getTimezoneOffset()
      var gw={}
      // cl(this.zone)
      switch(this.zone.gatewayType){
        case 800:
          id=getParamId800("igR","controllerTime")
//           cl(id)
          break
        case 1900:
          id=getParamId("snapshots","currentTime")
//           cl(id)
          let tzId=getParamId2(this.zone.gatewayType,"pearl_config","time_TimeZoneShift_mins")
//           cl(tzId)
          tzo=((dbVals.z[this.zInd||0]||{})[240]||{})[tzId]||0
          gw=globs.gatewaysInfo.info.filter(gw=>{return gw.gatewayId==this.zone.gatewayId})[0]
//           cl(this.zone)
//           cl(gw)

//           cl(tzo)
          break
        case 1800:
        default:
          id=getParamId("snapshots","unix_timestamp(unitTime)")
          break
      }
//       let id=(this.zone.gatewayType==1900)?// Pearl
//         getParamId("snapshots","currentTime"):
//       let id=getParamId("snapshots","unix_timestamp(unitTime)")
//       cl(this.zInd)
      let ts=+((dbVals.z[this.zInd||0]||{})[240]||{})[id]||0
//       cl(ts,id)
      let newUpdate=(getTime()-ts)<900
//       cl(ts,this.zInd,id)
      let tzIndicator=getTZIndicator(tzo)
      // LINK4: iDoser zones are flagged by the 4th segment of the gateway fw version (e.g. 1.9.0.I)
      let isIDoser=((gw?.fwVersion||"").split(".")[3]=="I")||
        this.zoneInfo.doserZone
//       cl(gw.fwVersion)
//       if((this.zone.gatewayType==1900)&&(gw?.fwVersion<"1.16.3")){
//         ts=ts+60*tzo
//       }
//       let hideGroup=(globs.userData.session.groupId&&
//         !globs.usersInfo.groupInfo?.allowSelectZone)?(
//         <div id="zone_group_sensors" style={{position:"absolute",left:0,top:0,width:"100%",
//           height:"100%",borderRadius:10,backgroundColor:"#00CC88",opacity:0.2,cursor:"pointer"}}
//           onClick={e=>this.props.parms.onChange({cmd:"sensorWrench", val:{wrenchCmd:"wrench"}})}
//         />
//
//       ):null
//             {hideGroup}

//       cl([id,ts])
//       cl(this.zoneInfo)
      return (
          <section id="sensors1800" className={`link4 left-half ${this.state.isHR16 ? "hr16-left" : ""}`} style={{position:"relative"}}>
            <C18DateFormat00 parms={{
              leftString: dateToDisplayDate(new Date(1000*ts),
                "mm/dd/yyyy h:mm ap",0)+` ${tzIndicator}`,
              leftClass: `date${(this.zone.connected||this.zone.virtual||newUpdate)?"":" not-synced"}`,
              parent:"dash",
              type: "quickWrench",
              ariaLabel: "sensor settings",
              value: this.state.tileMode,
              valueId: "tileMode",
              gatewayType:globs.zonesInfo.info[getZoneIndex(this.props.parms.zone)].gatewayType,
              weather: false,
              siteId: this.props.parms.site,
              zoneId: this.zoneInfo.zoneId,
              viewId: this.zoneInfo.viewId||"",
              apiKey: this.apiKey,
              isHR16: this.state.isHR16,
              isIDoser: isIDoser,
              onChange: (val)=>this.props.parms.onChange({cmd:"sensorWrench", val:val})
            }}/>
            {/* {this.showConnected()} */}
            <div className="sensor-grid">{this.showSensors()}</div>
          </section>
      )
    }else{
      return <div id="content-area">loading sensors. . .</div>
    }
  }
}
      
export default C18ZoneSensors00;
